const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');

// @commons
const { PopoverMenu } = require('commonsComponents/popoverMenu');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { removeCurrentSectionOption } = require('utilities/moreOptionsHelper');
const { taggingEventHandled } = require('utilities/taggingEventHandled');

// @ constants
const {
    BROKER_MIFID_FUTURES_ID,
    MYPROFILE_BROKER_CONSULT_MIFID_URL,
    BROKER_CORPORATE_OPERATIONS_URL,
    BROKER_DOCUMENTATION_URL,
    MYPROFILE_BROKER_INTERNAL_TRANSFER_FUND,
    BROKER_TRANSFER_EXTERNAL_VALUES,
    BROKER_TRANSFER_PENSION_PLAN_URL,
    BROKER_TRANSFER_CALLME_BACK_EXTERNAL_VALUES_URL,
    BROKER_EMPTY_PRODUCTS
} = require('constants/index');

const {
    BRING_MY_FUNDS,
    BRING_MY_FUNDS_INFO_VIEW,
    BRING_VALUES_TO_OK,
    BROKER_CAMBIOS_COMERCIALIZADORA,
    OPENTRADER,
    FUNDS_TRANSFER,
    DIVERSIFIED_INVESTMENT,
    WB_CRF,
    BROKERAGE,
    TYPE_PLANS,
    TYPE_STOCKS
} = require('constants/flagBasedFeatures');
const { PROC_INVESTMENT_BROKER_PG_NAME } = require('utilities/tagging');

// @hocs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';
import { BROKER_CONTRIBUTION_MANAGMENT_URL } from '../../../constants';

class BrokerGeneralMoreOptionsButton extends React.Component {
    constructor(props) {
        super(props);

        this.handleHireDerivativesClick = this.handleHireDerivativesClick.bind(this);
        this.handleOpenHireClick = this.handleOptionsClick.bind(this);
    }

    handleClickBuildYourPortfolio(){
        const url = formatText('brokerGeneralMoreOptions-buildYourPortfiolioUrl');
        window.location.href = url;
    }

    handleOptionsClick(item) {
        const { isUsPerson, flagBasedFeatures, openModal} = this.props;
        const ffUsPresonOpentrader = flagBasedFeatures.get('wealth_opentrader_us_person');
        if (item === "opentrader" && isUsPerson && ffUsPresonOpentrader) {
            openModal()
        } else {
            taggingEventHandled(PROC_INVESTMENT_BROKER_PG_NAME, 'pgOptionsMenu',  item )
            const actions = {
                'openStocksAccount': this.props.onOpenHireClick,
                'buildYourPortfolio': this.handleClickBuildYourPortfolio,
                'opentrader': this.props.onOpenTraderClick
            }
            item && actions[item] && actions[item]()
        }
    }

    buildMoreOptions() {
        const { flagBasedFeatures, plans } = this.props;
        const transferExternalSecuritiesToOKEnabled = flagBasedFeatures.get(BRING_VALUES_TO_OK);
        const transferExternalSecuritiesEnabled = flagBasedFeatures.get(BROKER_CAMBIOS_COMERCIALIZADORA);
        let options = [
            {
                link: '/myprofile/broker/ordersAndMovements',
                text: formatText('brokerGeneralMoreOptions-ordersAndMovements'),
                handleClick: () => this.handleOptionsClick('movementsAndOrders')
            },
            ...flagBasedFeatures.get(BROKERAGE) ?
            {
                handleClick: () => this.handleOptionsClick('openStocksAccount'),
                text: formatText('brokerGeneralMoreOptions-stocksContract')
            } : [],
            ...((transferExternalSecuritiesToOKEnabled && flagBasedFeatures.get(TYPE_STOCKS)) ? {
                link: BROKER_TRANSFER_CALLME_BACK_EXTERNAL_VALUES_URL,
                text: formatText('brokerMyInvestmentsMoreOptions-traspassValuesToOpenbank'),
                handleClick: () => this.handleOptionsClick('getMyStocks')

            } : []),
            ...flagBasedFeatures.get(DIVERSIFIED_INVESTMENT) ?
            {
                handleClick: () => this.handleOptionsClick('buildYourPortfolio'),
                text: formatText('brokerGeneralMoreOptions-buildYourPortfolioLinkText'),
            } : [],
            ...flagBasedFeatures.get(BRING_MY_FUNDS) ? flagBasedFeatures.get(BRING_MY_FUNDS_INFO_VIEW) ? {
                link: '/myprofile/broker/externalTransferFundInfoView',
                text: formatText('brokerGeneralMoreOptions-externalTransferFund'),
                handleClick: () => this.handleOptionsClick('getMyFunds')
            } : {
                link: '/myprofile/broker/externalTransferFund',
                text: formatText('brokerGeneralMoreOptions-externalTransferFund'),
                handleClick: () => this.handleOptionsClick('getMyFunds')
            } : [],
            ...flagBasedFeatures.get(FUNDS_TRANSFER) ? {
                link: MYPROFILE_BROKER_INTERNAL_TRANSFER_FUND,
                text: formatText('brokerGeneralMoreOptions-internalTransferFund'),
                handleClick: () => this.handleOptionsClick('transferBetweenFunds')
            } : [],
            ...((transferExternalSecuritiesEnabled && flagBasedFeatures.get(TYPE_STOCKS)) ? {
                link: BROKER_TRANSFER_EXTERNAL_VALUES,
                handleClick: () => this.handleOptionsClick('getMyStocks'),
                text: formatText('breadcrumb-breadcrumb_externalTransferValues', [
                    formatText(`externalTransferValues-externalTransferValues_values`)
                ])
            } : []),
            ...flagBasedFeatures.get(TYPE_PLANS) ?
            {
                link: BROKER_TRANSFER_PENSION_PLAN_URL,
                handleClick: () => this.handleOptionsClick('getMyPensionsPlan'),
                text: formatText('brokerGeneralMoreOptions-brokerGeneralMoreOptions_bringPlansToOpenBank')
            } : [],
            ...(plans > BROKER_EMPTY_PRODUCTS?
            {
                link: BROKER_TRANSFER_PENSION_PLAN_URL,
                handleClick: () => this.handleOptionsClick('transferBetweenPlans'),
                text: formatText('brokerMyInvestmentsMoreOptions-traspassBetweenMyPlans')
            }:[]),
            ...flagBasedFeatures.get(BROKERAGE) ?
            {
                link: BROKER_CORPORATE_OPERATIONS_URL,
                handleClick: () => this.handleOptionsClick('ongoingTransactions'),
                text: formatText('brokerGeneralMoreOptions-corporatesOperations')
            } : [],
            ...flagBasedFeatures.get(WB_CRF) ? {
                link: BROKER_DOCUMENTATION_URL,
                text: formatText('brokerGeneralMoreOptions-documentation'),
            } : [],
            {
                link: MYPROFILE_BROKER_CONSULT_MIFID_URL,
                handleClick: () => this.handleOptionsClick('mifidTest'),
                text: formatText('brokerGeneralMoreOptions-convenienceMiFIDTest')
            },
            ...flagBasedFeatures.get('wealth_funds_periodic_contributions') ? {
                link: BROKER_CONTRIBUTION_MANAGMENT_URL,
                handleClick: () => this.handleOptionsClick('contributionManagment'),
                text: formatText('brokerGeneralMoreOptionsWealth-contributionManagment')
            } : [],
            ...(!__CONTACT_CENTER__ && flagBasedFeatures.get(OPENTRADER)? {
                handleClick: () => this.handleOptionsClick('opentrader'),
                text: formatText('brokerGeneralMoreOptions-opentrader')
            } : []),
            ...(flagBasedFeatures.get('watchlist-enabled') ? {
                link: '/myprofile/broker/watchlist',
                text: formatText('brokerFavoriteWidget-brokerFavoriteWidget_Title')
            } : []),
        ];

        return removeCurrentSectionOption(options);
    }

    handleHireDerivativesClick() {
        const productName = ''; // @hardcoded
        const productUrl = ''; // @hardcoded
        const productId = BROKER_MIFID_FUTURES_ID;
        const urlContinueOperation = '/myprofile/broker/hire-derivatives-account/wizard';

        this.props.onStartConvenienceMiFIDTest(
            this.props.history,
            productName,
            productUrl,
            productId,
            urlContinueOperation
        );

        this.props.history.push('/myprofile/broker/convenience-mifid-test/wizard');
    }

    render() {
        const moreOptions = this.buildMoreOptions();
        const targetElement = (
            <div className="broker-general-view__action-link-btn--options">
                <OKButton
                    modifier={this.props.modifier}
                    inverse={this.props.inverse}
                    rightIcon="icon-dropdown-abrir"
                    smallRightIcon={true}
                >
                    <FormattedText value={this.props.textButton} />
                </OKButton>
            </div>
        );
        const content = (
            <PopoverMenu target={targetElement} items={moreOptions} placement="bottomRight" />
        );

        return content;
    }
}

BrokerGeneralMoreOptionsButton.propTypes = {
    flagBasedFeatures: PropTypes.object,
    history: PropTypes.object.isRequired,
    onStartConvenienceMiFIDTest: PropTypes.func.isRequired,
    funds: PropTypes.object,
    plans: PropTypes.number,
    onOpenTraderClick: PropTypes.func.isRequired,
    onOpenHireClick: PropTypes.func.isRequired,
    modifier: PropTypes.string,
    textButton: PropTypes.string,
    inverse: PropTypes.bool,
    isUsPerson: PropTypes.bool,
    openModal: PropTypes.func
};

BrokerGeneralMoreOptionsButton.defaultProps = {
    modifier: "ghost",
    textButton: "accounts-moreOptions",
    inverse: true
};

module.exports = withFeatureToggling(withRouter(BrokerGeneralMoreOptionsButton));
